const utilityTokenIdsConst = [
  244, 630, 631, 632, 633, 634, 635, 661, 708, 709, 710, 711, 712, 713, 725,
  726, 727, 761, 762, 763,
] as const;

type UtilityTokenRegistry = Record<
  (typeof utilityTokenIdsConst)[number],
  string
>;

const utilityTokenRegistry: UtilityTokenRegistry = {
  244: 'beta pass',
  630: 'Crystal Dream — Vol. III',
  631: 'Darius Brembley — Echo Chamber',
  632: 'Electric Breakfast',
  633: 'Tony and the Tones — Fresh Hair',
  634: 'The Alpha Centauri Players — Songs in the Key of Ø',
  635: "Mr Magnificent's Salty Springtime Boogie",
  661: 'project gray poster',
  708: 'not in the store album art',
  709: 'holographic not in the store album art',
  710: 'gold not in the store album art',
  711: "can't hold me down album art",
  712: "holographic can't hold me down album art",
  713: "gold can't hold me down album art",
  725: 'dullsville and the doodleverse poster',
  726: 'holographic dullsville and the doodleverse poster',
  727: 'gold dullsville and the doodleverse poster',
  761: 'doodleverse (draw me closer) album art',
  762: 'holographic doodleverse (draw me closer) album art',
  763: 'gold doodleverse (draw me closer) album art',
};

const utilityTokenIds: number[] = [...utilityTokenIdsConst];

export { utilityTokenIds, utilityTokenRegistry };
